<!-- <div class="loader"></div> -->
<div class="loader-svg">
    <span class="loading-span">
        <img src="/assets/animations/spinner.svg">
    </span>
</div>
